import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MainTableColumn,
  MainTableColumnId,
  MainTableSorting,
} from '@prlw/core/monitor/types/main-table';
import { ModifiersOverlayService } from '../../../modifiers-overlay/modifiers-overlay.service';
import { MainTableService } from '../main-table.service';
import { MainTableModifiersService } from '@prlw/core/monitor/main-table-modifiers.service';
import { map } from 'rxjs/operators';
import { ModifierType } from '@prlw/core/monitor/types/common';
import { MainTableInstrumentsService } from '@prlw/core/monitor/main-table-instruments.service';
import {
  mapPending,
  mapResult,
} from '@prlw/infrastructure/observableWithPending-v2';

@Component({
  selector: 'prlw-main-table-header',
  templateUrl: './main-table-header.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainTableHeaderContainer {
  public readonly columns$: Observable<MainTableColumn<MainTableColumnId>[]>;
  public readonly sorting$: Observable<MainTableSorting>;
  public readonly gridSize$: Observable<string>;
  public readonly isModifiersOverlayOpen$: Observable<boolean>;
  public readonly isModifierChanged$: Observable<boolean>;

  constructor(
    private readonly modifiersOverlayService: ModifiersOverlayService,
    private readonly mainTableService: MainTableService,
    private readonly mainTableModifiersService: MainTableModifiersService,
    private readonly mainTableInstrumentsService: MainTableInstrumentsService,
  ) {
    this.columns$ = mainTableService.visibleColumnsLocalPriceFirst$;
    this.sorting$ = mainTableService.sorting$;
    this.gridSize$ = mainTableService.gridSize$;
    this.isModifiersOverlayOpen$ = modifiersOverlayService.isOpen$;
    this.isModifierChanged$ = mainTableModifiersService.modifier$.pipe(
      map((mod) => mod.type !== ModifierType.SIMPLE),
    );
  }

  preloaderActive$ =
    this.mainTableInstrumentsService.reqInstrumentsWithPending$.pipe(
      mapPending,
    );
  reqInstrumentsResult$ =
    this.mainTableInstrumentsService.reqInstrumentsWithPending$.pipe(mapResult);

  public sortColumn(columnId: MainTableColumnId): void {
    this.mainTableService.sortColumn(columnId);
  }

  public openModifiersOverlay(): void {
    this.modifiersOverlayService.open();
  }

  public handleUpdateColumns(columns: MainTableColumn<MainTableColumnId>[]) {
    this.mainTableService.updateColumns(columns);
  }
}
